import Vue from 'vue'
import Vuex from 'vuex'

// Modules
// import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userisloggued: localStorage.getItem('userisloggued') === 'true' || false,
    bearer: localStorage.getItem('bearer') || '',
    geoinfos: {},
    accessmode: '',
    userData: JSON.parse(localStorage.getItem('userData') || "{}"),
    language: localStorage.getItem('language') || null,
    userForm: {
      firstname: '',
      lastname: '',
      language: '',
    },
  },
  mutations: {
    updateUserForm(state, newData) {
      state.userForm = newData
    },
  },
  modules: {
    app,
    appConfig,
    verticalMenu,
  //   'app-ecommerce': ecommerceStoreModule,
  },
  strict: process.env.DEV,
})
